(() => {
  'use strict';
  const host = document.getElementById('ssw-aliigo-position');
  if (!host || host.dataset.positioned) return;
  host.dataset.positioned = 'true';
  let frame = 0;
  const update = () => {
    frame = 0;
    const mobile = window.matchMedia('(max-width: 640px)').matches;
    // Documented absolute-mode renderer padding; checked against rendered geometry.
    const paddingBottom = mobile ? 8 : 24;
    const paddingRight = mobile ? 8 : 0;
    const vv = window.visualViewport;
    const viewportWidth = vv ? vv.width : window.innerWidth;
    const viewportHeight = vv ? vv.height : window.innerHeight;
    const viewportTop = vv ? vv.offsetTop : 0;
    const keyboardInset = Math.max(0, window.innerHeight - viewportHeight - viewportTop);
    // Shopify's preview iframe spans the viewport but its mobile toolbar occupies
    // the bottom 64px. Reserve that toolbar only when the preview frame exists.
    const previewFrame = document.getElementById('PBarNextFrame');
    const previewClearance = previewFrame && getComputedStyle(previewFrame).display !== 'none' ? 80 : 0;
    document.documentElement.style.setProperty('--ssw-preview-bar-clearance', `${previewClearance}px`);
    let reserve = Math.max(0, previewClearance - 16);
    document.querySelectorAll('.sticky-atc-bar--show, .mobile-sticky-bar').forEach(bar => {
      const style = getComputedStyle(bar);
      if (style.display === 'none' || style.visibility === 'hidden') return;
      const rect = bar.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      if (bar.classList.contains('sticky-atc-bar--show')) {
        // Reserve its final occupied area during the entrance transition too.
        reserve = Math.max(reserve, rect.height + (parseFloat(style.bottom) || 0));
      } else if (rect.top < window.innerHeight) {
        reserve = Math.max(reserve, window.innerHeight - rect.top);
      }
    });
    const arrow = document.querySelector('back-to-top');
    const arrowRect = arrow?.getBoundingClientRect();
    // Native floating navigation must also yield when it covers a contextual
    // control. Keep its dimensions for stable positioning while hidden, and
    // restore it as soon as the shopper scrolls beyond the overlap.
    if (arrow) {
      const obstructsContext = arrowRect?.width > 0 && [...document.querySelectorAll(
        '[data-ssw-aliigo] button'
      )].some(button => {
        const rect = button.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0 &&
          Math.min(rect.right, arrowRect.right) > Math.max(rect.left, arrowRect.left) &&
          Math.min(rect.bottom, arrowRect.bottom) > Math.max(rect.top, arrowRect.top);
      });
      arrow.toggleAttribute('data-ssw-aliigo-obstructs-control', obstructsContext);
    }
    // The native arrow moves when the sticky purchase bar animates. Its final
    // position can cross a control after the last scroll event, so track that
    // short transition until it settles instead of leaving stale hit geometry.
    if (arrow?.getAnimations().some(animation => animation.playState === 'running')) schedule();
    const arrowBottom = arrow ? (parseFloat(getComputedStyle(arrow).bottom) || 16) : 16;
    // On mobile reserve the arrow vertically for both closed and open states.
    // This preserves chat width without depending on private widget state.
    const arrowClearance = mobile && arrowRect?.height ? arrowBottom + arrowRect.height + 12 : arrowBottom;
    const baseline = Math.max(reserve + 16, arrowClearance);
    const right = !mobile && arrowRect?.width
      ? Math.max(16, window.innerWidth - arrowRect.left + 12 - paddingRight)
      : 16;
    const bottom = Math.max(0, baseline - paddingBottom) + keyboardInset;
    const width = Math.max(1, Math.min(420, viewportWidth - right - 16));
    const height = Math.max(1, Math.min(640, window.innerHeight - bottom - viewportTop - 16));
    for (const [key, value] of Object.entries({right,bottom,width,height})) {
      host.style.setProperty(`--ssw-assistant-${key}`, `${Math.round(value)}px`);
    }
    // Core's public launcher-only control leaves an explicitly opened chat usable.
    // Contextual help takes priority whenever it is visible, including desktop:
    // the fixed launcher can otherwise cover the right-aligned entry link.
    // Inline purchase controls additionally take priority on small screens.
    // Landscape phones and narrow tablets can still overlap the purchase area
    // while using the renderer's wider-screen padding; keep these rules separate.
    const protectInlineControls = window.matchMedia('(max-width: 1023px)').matches;
    const protectedEntryVisible = [...document.querySelectorAll(
      protectInlineControls
        ? '.product__block--buy_buttons, .product__block--variant_picker, [data-ssw-aliigo]'
        : '[data-ssw-aliigo]'
    )].some(element => {
      const style = getComputedStyle(element);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      const rect = element.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.bottom > viewportTop &&
        rect.top < viewportTop + viewportHeight && rect.right > 0 && rect.left < viewportWidth;
    });
    const widget = host.querySelector('aliigo-widget');
    const launcherVisibility = protectedEntryVisible ? 'hidden' : 'auto';
    if (widget && widget.getAttribute('launcher-visibility') !== launcherVisibility) {
      widget.setAttribute('launcher-visibility', launcherVisibility);
    }
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  window.addEventListener('scroll', schedule, {passive:true});
  window.addEventListener('resize', schedule, {passive:true});
  window.visualViewport?.addEventListener('resize', schedule, {passive:true});
  window.visualViewport?.addEventListener('scroll', schedule, {passive:true});
  const sizes = new ResizeObserver(schedule);
  const state = new MutationObserver(schedule);
  state.observe(document.body, {attributes:true,attributeFilter:['class','style']});
  const tracked = new WeakSet();
  const trackControls = () => document.querySelectorAll(
    'back-to-top, .sticky-atc-bar, .mobile-sticky-bar, .product__block--buy_buttons, .product__block--variant_picker, [data-ssw-aliigo], #PBarNextFrame'
  ).forEach(el => {
    if (tracked.has(el)) return;
    tracked.add(el);
    sizes.observe(el);
    state.observe(el, {attributes:true,attributeFilter:['class','style','hidden','open']});
  });
  trackControls();
  // Shopify can insert the preview toolbar or replace product sections after boot.
  new MutationObserver(() => { trackControls(); schedule(); })
    .observe(document.body, {childList:true,subtree:true});
  document.addEventListener('shopify:section:load', schedule);
  schedule();
})();
